
window.handleBarChart = function(data, divId) {
    "use strict";

    var barChartData = [{
        key: 'Cumulative Return',
        values: data
    }];

    nv.addGraph(function() {
        var barChart = nv.models.discreteBarChart()
            .x(function(d) { return d.label })
            .y(function(d) { return d.value })
            .showValues(false)
            .duration(250);

        barChart.yAxis.axisLabel("Volume");
        barChart.xAxis.axisLabel("Month");
        barChart.yAxis.tickFormat(d3.format('$,.2s'));
        barChart.color(['#4a3553', '#00acac', '#ff5b57', '#f59c1a', '#727cb6', '#49b6d6']);

        d3.select(divId).append('svg').datum(barChartData).call(barChart);
        nv.utils.windowResize(barChart.update);

        return barChart;
    });
};

window.handleStackedBarChart = function(data, divId) {
    nv.addGraph(function() {
        var chart = nv.models.multiBarChart();

        chart.yAxis.axisLabel("Count");
        chart.xAxis.axisLabel("Month");
        chart.yAxis.tickFormat(d3.format('$,.2s'));
        
        chart.multibar.stacked(true); // default to stacked
        chart.showControls(false); // don't show controls
        
        chart.color(['#4a3553', '#00acac', '#ff5b57', '#f59c1a', '#727cb6', '#49b6d6']);

        chart.showLegend(false);

        d3.select(divId).append('svg')
            .datum(data)
          .transition().duration(500).call(chart);

        nv.utils.windowResize(chart.update);

        return chart;
    });
}

window.handlePieAndDonutChartTotal = function(data, divId) {
    "use strict";

    nv.addGraph(function() {
        var pieChart = nv.models.pieChart()
            .x(function(d) { return d.label })
            .y(function(d) { return d.value })
            .showLabels(true)
            .labelThreshold(.05);

            pieChart.color(['#4a3553', '#00acac', '#ff5b57', '#f59c1a', '#727cb6', '#49b6d6']);

        d3.select('#nv-pie-chart').append('svg')
            .datum(data)
            .transition().duration(350)
            .call(pieChart);

        nv.utils.windowResize(pieChart.update);

        return pieChart;
    });


    nv.addGraph(function() {
        var chart = nv.models.pieChart()
            .x(function(d) { return d.label })
            .y(function(d) { return d.value })
            .showLabels(true)
            .labelThreshold(.05)
            .labelType("value")
            .donut(true)
            .donutRatio(0.35);

            chart.color(['#4a3553', '#00acac', '#ff5b57', '#f59c1a', '#727cb6', '#49b6d6']);
            d3.select(divId).style("fill-opacity", .8);

        d3.select(divId).append('svg')
            .datum(data)
            .transition().duration(350)
            .call(chart);

        return chart;
    });
};
